import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const TnaStatus = () => {
	const dataList = [
		{ label: 'Due soon', value: 'DUE_SOON' },
		{ label: 'Red alert', value: 'RED_ALERT' },
		{ label: 'Safe', value: 'SAFE' },
		{ label: 'Shipped', value: 'SHIPPED' },
		{ label: 'Unsafe', value: 'UNSAFE' }
	];
	const filterData = useSelector((store) => store.filterFieldStore);

	const dispatch = useDispatch();

	const renderDataList = () => {
		return dataList?.map((item) => {
			return (
				<div className="form-group" key={`filter_tnaStatus_${item.value}`}>
					<input
						type="checkbox"
						id={`tnaStatus_${item.value}`}
						name={`tnaStatus_${item.value}`}
						value={item.value}
						onChange={(e) => handleCheckbox(e, item.label)}
						checked={toggleCheckbox(
							filterData,
							'tnaStatus',
							`tnaStatus_${item.value}`,
							item.value
						)}
					/>
					<label htmlFor={`tnaStatus_${item.value}`}>
						<span>{item.label}</span>
					</label>
				</div>
			);
		});
	};

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'tnaStatus',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	return (
		<div className="card">
			<div className="card-header" id="headingFive">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#tnaStatus"
						aria-expanded="false"
						aria-controls="tnaStatus"
					>
						TNA Status
					</button>
				</h5>
			</div>

			<div id="tnaStatus" className="collapse" aria-labelledby="headingFive" data-parent="#accordion">
				<div className="card-body">
					<div className="custom-chekbox">{renderDataList()}</div>
				</div>
			</div>
		</div>
	);
};

export default TnaStatus;
